import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodsSlideComponent } from './payment-methods-slide.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { PaymentMethodVccModule } from '../payment-method-vcc/payment-method-vcc.module';
import { SlideModule } from '@app/core/components/slide/slide.module';

@NgModule({
    declarations: [PaymentMethodsSlideComponent],
    exports: [PaymentMethodsSlideComponent],
    imports: [CommonModule, MatButtonModule, SlideModule, PaymentMethodVccModule]
})
export class PaymentMethodsSlideModule {}
